import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { OwnerConfigurationFormModel } from 'src/Libs/installations/models/installation.model'
import { z } from 'zod'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useMemo } from 'react'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { UserContactInfo } from 'src/State/User/UserModel'

export const useOwnerConfigurationFormInitializer = (
  invitation?: InstallationInvitationModel,
  userData?: UserContactInfo
): FormInitializerReturnTypeZod<OwnerConfigurationFormModel, OwnerConfigurationFormModel> => {
  const { t } = useCustomTranslation()

  const initialValues: OwnerConfigurationFormModel = useMemo(() => {
    return {
      email: invitation?.accountId ?? userData?.email ?? '',
    }
  }, [invitation, userData])

  const validationSchema = z.object({
    email: z
      .string({ message: t(ValidationMessageKeys.required) })
      .email({ message: t(ValidationMessageKeys.emailFormat) })
      .trim(),
  })

  return { initialValues, validationSchema }
}
